import React, { useEffect, useState } from 'react';
const CountdownTimer = () => {
  const weddingDate = new Date('February 14, 2026 00:00:00').getTime();
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  function calculateTimeLeft() {
    const now = new Date().getTime();
    const difference = weddingDate - now;
    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
      minutes: Math.floor(difference % (1000 * 60 * 60) / (1000 * 60)),
      seconds: Math.floor(difference % (1000 * 60) / 1000)
    };
  }
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const timeUnits = [{
    label: 'Days',
    value: timeLeft.days
  }, {
    label: 'Hours',
    value: timeLeft.hours
  }, {
    label: 'Minutes',
    value: timeLeft.minutes
  }, {
    label: 'Seconds',
    value: timeLeft.seconds
  }];
  return <section className="bg-white py-16 md:py-20" data-id="element-22">
      <div className="max-w-5xl mx-auto px-4" data-id="element-23">
        <h2 className="text-center font-serif text-2xl md:text-3xl mb-10 text-gray-800" data-id="element-24">
          Counting Down to Our Special Day
        </h2>
        <div className="flex flex-wrap justify-center gap-4 md:gap-10" data-id="element-25">
          {timeUnits.map((unit, index) => <div key={index} className="flex flex-col items-center" data-id="element-26">
              <div className="w-20 h-20 md:w-28 md:h-28 flex items-center justify-center bg-champagne border border-gold border-opacity-30 rounded-md mb-2" data-id="element-27">
                <span className="font-serif text-3xl md:text-4xl text-gray-800" data-id="element-28">
                  {unit.value.toString().padStart(2, '0')}
                </span>
              </div>
              <span className="font-sans text-xs md:text-sm uppercase tracking-wider text-gray-600" data-id="element-29">
                {unit.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};
export default CountdownTimer;